import { Card, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
export default function HelpSupportSection() {
  const { t } = useTranslation();

  return (
    <Card>
      <Card.Header>
        <h5 className="mb-0">
          <i className="fas fa-envelope me-2" />
          {t('help.support_title')}
        </h5>
      </Card.Header>
      <Card.Body>
        <p>{t('help.support_desc')}</p>
        <ul>
          <li>
            <strong>{t('help.support_system_admin')}</strong>: {t('help.support_system_admin_desc')}
          </li>
          <li>
            <strong>{t('help.support_contact_title')}</strong>: {t('help.support_contact_desc')}
          </li>
          <li>
            <strong>{t('help.support_feature_request')}</strong>:{' '}
            <Link to="/contact">{t('help.support_feature_request_desc')}</Link>
          </li>
          <li>
            <strong>{t('help.support_log_check')}</strong>: {t('help.support_log_check_desc')}
          </li>
        </ul>
        <Alert variant="info" className="mt-3">
          <i className="fas fa-info-circle me-2" />
          <strong>{t('help.contact_info_title')}</strong>
          <br />
          {t('help.contact_info_desc')}
        </Alert>
        <div className="d-flex flex-wrap gap-2 mt-3">
          <Link to="/contact" className="btn btn-primary">
            <i className="fas fa-paper-plane me-2" />
            {t('help.contact_button')}
          </Link>
        </div>
      </Card.Body>
    </Card>
  );
}
